import React from 'react'
import { useCallback, useContext } from 'sb-hooks'
import { NotificationContext } from 'sb-notify-me'
import actions from 'redux/actions'
import { links } from 'common/helpers'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


type SeveralQueueItemsNotificationProps = {
  itemsCount: number
  onClose?: () => void
}

const SeveralQueueItemsNotification: React.FunctionComponent<SeveralQueueItemsNotificationProps> = ({ onClose, itemsCount }) => {
  const { close } = useContext(NotificationContext)

  const handleClick = useCallback(() => {
    close()

    actions.models.router.push(links.queue)

    if (typeof onClose === 'function') {
      onClose()
    }
  }, [ close, onClose ])

  return (
    <div onClick={handleClick}>
      <Box pt={36} pb={36} relative>
        <Text
          size="14-24"
          message={{ ...messages.text, values: { itemsCount } }}
          align="center"
          semibold
          uppercase
        />
      </Box>
    </div>
  )
}


export default SeveralQueueItemsNotification
